export const c_button_m_progress_PaddingRight = {
  "name": "--pf-c-button--m-progress--PaddingRight",
  "value": "calc(1rem + calc(1.125rem + 0.5rem) / 2)",
  "var": "var(--pf-c-button--m-progress--PaddingRight)"
};
export default c_button_m_progress_PaddingRight;